import Amplify from 'aws-amplify'
import AWS from 'aws-sdk'

const state = {
  cognitoConfig: null,
  loggedInUser: null,
  hasToken: true // default to assume we have token
}

const mutations = {
  setLoggedInUser(state, user) {
    state.loggedInUser = user
  },
  setHasToken(state, hasToken) {
    state.hasToken = hasToken
  },
  setCognitoConfig(state, cognitoConfig) {
    state.cognitoConfig = cognitoConfig
  }
}

const actions = {
  setLoggedInUser: ({ commit }) => commit('setLoggedInUser'),
  checkAuthentication({ commit, state }, payload) {
    commit('setLoggedInUser', null)
    Amplify.Auth.currentAuthenticatedUser()
      .then((user) => {
        commit('setLoggedInUser', user)
      })
      .then(() => {
        Amplify.Auth.currentCredentials().then((credentials) => {
          AWS.config.update({ credentials: credentials })
          commit('setHasToken', true)
        })
      })
      .catch((err) => {
        commit('setLoggedInUser', null)
        commit('setHasToken', false)
        this.status = `Error checking authenticated user: ${err}`
      })
  },
  logout({ commit, state }, payload) {
    Amplify.Auth.signOut().then((data) => {
      commit('replaceSurveys', null)
      commit('replaceSurvey', null)
      commit('setLoggedInUser', null)
    })
  }
}

// getters are functions
const getters = {
  cognitoConfig: (state) => {
    return state.cognitoConfig
  },
  loggedInUser: (state) => {
    return state.loggedInUser
  },
  hasToken: (state) => {
    return state.hasToken
  },
  isAdmin(state, getters, rootState) {
    const loggedInUser = state.loggedInUser
    return (
      loggedInUser &&
      loggedInUser.signInUserSession &&
      loggedInUser.signInUserSession.idToken.payload.userIsAdmin === 'true'
    )
  },
  userHasAttributeInList: (state, getters) => (attributes) => {
    const userAttributes = getters.userInfo.attributes
    if (userAttributes && attributes && attributes.length) {
      // If any of the attributes are present for user with the
      // wanted value, then return true
      // i.e. if attribute = {name: 'gender', value: 'male'}
      // and userAttributes contains key gender and value is also 'male'
      // then break and return true
      return attributes.filter((attribute) => {
        const userAttributeValue = userAttributes[attribute.name]
        // console.log(`userAttribute value: ${userAttributeValue} for attribute ${attribute.name} which we check for value: ${attribute.value}`)
        if (userAttributeValue && userAttributeValue === attribute.value) {
          return true
        } else {
          return false
        }
      }).length
    } else {
      return false
    }
  },
  userInfo(state, getters, rootState) {
    const user = state.loggedInUser
    if (user && user.signInUserSession && user.signInUserSession.idToken) {
      const groups = user.signInUserSession.idToken.payload['cognito:groups']
      const info = user.signInUserSession.idToken.payload
      const groupName = groups[0] // this is a naive approach, but well.
      return {
        username: user.username, // TODO: Use attributes
        organizationName:
          user.signInUserSession.idToken.payload.organizationName,
        organizationFullName:
          user.signInUserSession.idToken.payload.organizationFullName,
        organizationLogoUrl:
          user.signInUserSession.idToken.payload.organizationLogoUrl,
        groupName: groupName,
        attributes: user.signInUserSession.idToken.payload,
        fullName:
          info.given_name && info.family_name
            ? `${info.given_name} ${info.family_name}`
            : info.email,
        groups
      }
    } else {
      return {}
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
